import { useState, type FormEvent } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { Alert, AuthCard, Button, Field } from '../components/ui'
import { useVerifyMfa } from '../lib/session'

export default function MfaPage() {
  const navigate = useNavigate()
  const verify = useVerifyMfa()
  const [code, setCode] = useState('')
  const [useRecoveryCode, setUseRecoveryCode] = useState(false)

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    verify.mutate(
      { code, useRecoveryCode },
      { onSuccess: () => void navigate({ to: '/' }) },
    )
  }

  const expired = verify.error?.message.includes('expire') === true

  return (
    <AuthCard
      title="Verification en deux etapes"
      subtitle={
        useRecoveryCode
          ? 'Saisissez un de vos codes de secours. Il ne sera utilisable qu une fois.'
          : 'Saisissez le code a six chiffres affiche par votre application d authentification.'
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Field
          label={useRecoveryCode ? 'Code de secours' : 'Code a six chiffres'}
          name="code"
          autoComplete="one-time-code"
          inputMode={useRecoveryCode ? 'text' : 'numeric'}
          autoFocus
          required
          value={code}
          onChange={(event) => setCode(event.target.value)}
        />

        {verify.isError && <Alert>{verify.error.message}</Alert>}

        <Button type="submit" disabled={verify.isPending}>
          {verify.isPending ? 'Verification...' : 'Valider'}
        </Button>
      </form>

      <div className="mt-4">
        <Button
          type="button"
          variant="ghost"
          onClick={() => {
            setUseRecoveryCode((previous) => !previous)
            setCode('')
            verify.reset()
          }}
        >
          {useRecoveryCode
            ? 'Utiliser mon application d authentification'
            : 'Utiliser un code de secours'}
        </Button>
      </div>

      {expired && (
        <div className="mt-4">
          <Button
            type="button"
            variant="ghost"
            onClick={() => void navigate({ to: '/login' })}
          >
            Revenir a la connexion
          </Button>
        </div>
      )}
    </AuthCard>
  )
}
